"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeToken = decodeToken;
var _jwtDecode = require("jwt-decode");
var _logger = require("../logger");
const logger = _logger.mainLogger.createChild('decodeToken');
function decodeToken(token) {
  if (!token) {
    return null;
  }
  try {
    return (0, _jwtDecode.jwtDecode)(token);
  } catch (error) {
    logger.error(new Error('Error happened during token decode', {
      cause: error
    }));
    return null;
  }
}
//# sourceMappingURL=decodeToken.js.map